import { render, staticRenderFns } from "./BuilderPage.vue?vue&type=template&id=672e096e&scoped=true&"
import script from "./BuilderPage.vue?vue&type=script&lang=js&"
export * from "./BuilderPage.vue?vue&type=script&lang=js&"
import style0 from "./BuilderPage.vue?vue&type=style&index=0&id=672e096e&scoped=true&lang=css&"
import style1 from "./BuilderPage.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "672e096e",
  null
  
)

export default component.exports